import { render } from "./AlarmModal.vue?vue&type=template&id=ce5e317a"
import script from "./AlarmModal.vue?vue&type=script&lang=js"
export * from "./AlarmModal.vue?vue&type=script&lang=js"

import "./AlarmModal.vue?vue&type=style&index=0&id=ce5e317a&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__